import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import { merchantApi } from '@src/api/openapi/merchantApi'
import { authApi } from '@src/api/openapi/empty'

export const RTKStore = configureStore({
  reducer: {
    auth: authReducer,
    [merchantApi.reducerPath]: merchantApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(merchantApi.middleware, authApi.middleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof RTKStore.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof RTKStore.dispatch
